import React from 'react';
import clsx from 'clsx';
import { HeroSlider } from '@/components/common/hero-slider/HeroSlider';
import Image from 'next/image';
import Images from '@/const/images';
import { ScaledFormCanvas } from '@/components/auth/ScaledFormCanvas';
import { usePathname } from 'next/navigation';
import AppRoutes from '@/const/routes';

interface Props {
	children: React.ReactNode;
	withCarrousel?: boolean;
	withEllipsesBg?: boolean;
}

export const AuthLayout: React.FC<Props> = ({
	children,
	withCarrousel = true,
	withEllipsesBg = false,
}) => {
	const pathname = usePathname();
	const isVerifyEmail =
		pathname === AppRoutes.CLIENTAPP_AUTH_VERIFY_EMAIL_FIRST_TIME;
	const listImages = [
		'/img/landing/svg/black-magic-woman.svg',
		'/img/landing/svg/white-boy.svg',
		'/img/landing/svg/latin-girl.svg',
	];
	return (
		<main
			className={clsx(
				"lg:bg-[url('/img/dashboard/bg-auth-client.svg')] bg-contain lg:bg-cover bg-no-repeat lg:bg-center overflow-y-auto lg:pb-16 xl:pb-0",
				'min-h-screen h-screen relative',
				{
					"bg-[url('/img/dashboard/authLayout.webp')]": isVerifyEmail,
				}
			)}
		>
			{withEllipsesBg && (
				<>
					<div className="lg:hidden absolute left-0 top-0 -z-10">
						<div className="relative h-[350px] w-[250px]">
							<div className="absolute -inset-10 bg-[url('/img/landing/svg/corner-bg.svg')] bg-contain bg-no-repeat" />
						</div>
					</div>
					<div className="absolute bottom-0 right-0 -z-10">
						<div className="relative h-[350px] w-[250px]">
							<div className="absolute -inset-0 bg-[url('/img/landing/ellipse-right-bottom.svg')] bg-contain bg-no-repeat" />
						</div>
					</div>
				</>
			)}
			<ScaledFormCanvas origin="center" activateBelow={{ w: 1440, h: 800 }}>
				<div className="flex items-center gap-4 2xl:gap-0 justify-center w-full min-h-screen 2xl:max-w-screen-[1100px]">
					<div className="w-full lg:w-[52%] flex justify-center">
						{children}
					</div>
					{withCarrousel && (
						<div className="flex-2 hidden md:block">
							<div className="flex flex-col justify-center items-center gap-[70px]">
								<Image
									src={Images.logoSVG}
									alt="Logo"
									width={199}
									height={38}
								/>
								<HeroSlider listItems={listImages} />
							</div>
						</div>
					)}
				</div>
			</ScaledFormCanvas>
		</main>
	);
};
